import React from 'react'
import { FiStar, FiUsers, FiMapPin,  FiBriefcase, FiChevronDown  } from 'react-icons/fi'

export const OpenPositions = ({requirements,projectId}) => {
    return ( 
        <React.Fragment>
              { requirements?.length>0 &&(
                    <div className="list_frame">
                        <div className="heading">
                            <h3>Açık Pozisyonlar</h3>
                            <div className="list_icon">
                                <FiChevronDown />
                            </div>
                        </div>
                        <p className="red"> message.title </p>
                        <div className={`project_show__positions no`}>
                            <ul>
                              {
                                    requirements?.map((item,i)=>{
                                    return (
                                        <li className="active" key={'requirement-'+i} >
                                            <div>
                                                <h3>Type</h3>
                                                <ul className="position_detail">
                                                    {item.city.length > 0 && <li><FiMapPin /> <p>{item.city.length} city {item.district?.length} province </p></li> }
                                                    {item.city.length <= 0 && item.district?.length>0 && <li><FiMapPin /> <p>{item.district?.length} province </p></li> }
                                                    
                                                    <li><FiBriefcase /> <p>{item.sector?.length} field</p></li>
                                                    <li><FiUsers /> <p>Require: {item.count} person</p></li>
                                                </ul>
                                            </div>
                                            <div className="position_icon" title="Apply">
                                                <FiStar />
                                            </div>
                                        </li>
                                    )})
                                }
                                
                            </ul>
                        </div>
                    </div> )}
        </React.Fragment>
    ) 
}
